<template>
    <div v-if="firstImage" class="py-1">
        <img :src="firstImage.url" :alt="field.name" class="h-10 w-10 rounded object-cover">
    </div>
    <span v-else>&mdash;</span>
</template>

<script>
export default {
    props: ['resourceName', 'field'],

    computed: {
        /**
         * First product image for the index table.
         *
         * @returns {{url: string}|null}
         */
        firstImage() {
            return (this.field.initialImages || [])[0] || null
        },
    },
}
</script>
